{
  "dss": {
    "button": {
      "back": "返回",
      "cancel": "取消",
      "close": "关闭",
      "confirmDelete": "是，删除",
      "continue": "继续",
      "logout": "退出登录",
      "passwordReset": "重置密码",
      "save": "保存",
      "verify": "验证"
    },
    "error": {
      "403": "您无权访问此页面。",
      "404": "该页面不存在。",
      "generic": "发生错误。请稍后重试。",
      "invalidConfirmationLink": "确认链接已过期或无效。",
      "throttling": "尝试次数过多。此操作已被暂时阻止。",
      "title": "错误",
      "title403": "访问被拒绝",
      "title404": "未找到"
    },
    "footer": {
      "imprint": "Imprint",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "隐私政策",
      "terms": "条款与条件"
    },
    "label": {
      "CRMAccountNumber": "CRM 账号",
      "contact": "联系",
      "email": "电子邮箱",
      "faq": "常见问题",
      "female": "女士",
      "firstname": "名",
      "help": "帮助",
      "language": "语言",
      "lastname": "姓",
      "male": "先生",
      "needHelp": "需要帮助吗？",
      "newPassword": "新密码",
      "newPassword2": "确认新密码",
      "oldPassword": "当前密码",
      "organization": "组织",
      "password": "密码",
      "required": "必填",
      "salutation": "称呼",
      "select": "请选择"
    },
    "lang": {
      "de": "德语"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "确认注册",
        "wait": "请稍候，正在完成账户确认。"
      },
      "otp": {
        "btnResend": "重新发送验证码邮件",
        "msg": {
          "invalidOTP": "输入的一次性密码无效。",
          "resendFail": "验证码重发失败。请稍后再试。"
        },
        "spamDetail": "请检查收件箱和垃圾邮件文件夹中来自 STIHL Support 的邮件 (noreply{'@'}stihl-sso.com)",
        "spamTitle": "没有收到邮件？",
        "subtitle": "要继续，请先验证您的电子邮箱地址。",
        "title": "验证您的用户账户",
        "txtVerifyMail": "请输入我们发送至您的电子邮箱地址 {email} 的新验证码"
      },
      "personal": {
        "msg": {
          "noChange": "没有需要更新的内容。",
          "updateError": "个人数据更新失败。",
          "updated": "个人数据已更新。",
          "userLoadErr": "加载用户数据时出错。请稍后重试。"
        },
        "secOrganization": "组织",
        "secPersonal": "个人",
        "secSettings": "首选设置",
        "title": "个人信息"
      },
      "postPwSet": {
        "info": "您现在可以使用新密码。",
        "link_name": "继续前往 Self-Service",
        "link_url": "/user/ui/",
        "title": "您的密码已更改"
      },
      "resetPW": {
        "title": "重置您的密码"
      },
      "security": {
        "2fa": {
          "availableMethods": "可用的 2FA 方法：",
          "info": "双重身份验证 (2FA) 是一项安全功能，可为您的账户增加一层额外保护。它要求您在登录时使用两种方式，而不仅仅是用户名和密码。",
          "method": {
            "email": "电子邮箱",
            "emailDesc": "通过电子邮件接收一次性验证码以完成身份验证请求。",
            "oath": {
              "add": {
                "button": "注册 Authenticator 应用"
              }
            }
          }
        },
        "authenticator": "Authenticator 应用",
        "infoFederatedAccount": "此账户由您所在组织的身份提供商管理，因此无法在此处更改密码。要更改密码，请通过您所在组织的登录页面登录，或联系您的 IT 管理员。",
        "lastUse": "上次使用时间：{0}。",
        "msg": {
          "invalidPassword": "提供的当前密码无效。",
          "passwordAlreadyUsed": "不能重复使用最近 5 个密码。",
          "pwUpdateError": "尝试更改密码时发生错误。",
          "pwUpdated": "密码已更改。"
        },
        "noDevice": "未配置",
        "oathAdd": {
          "appInfo": "为简化 STIHL 的登录流程，您可以使用 {0}、{1}、{2} 等 Authenticator 应用生成一次性密码，作为登录过程中的第二因素。<br/>如果您丢失或忘记了移动设备，您始终可以使用通过电子邮件发送的 2FA 代码。<br/><br/>请按照以下说明设置您的身份验证设备。",
          "badCode": "验证码无效，请重试。",
          "error": "注册身份验证设备时发生错误。",
          "headScan": "1. 使用 Authenticator 应用扫描二维码",
          "headVerify": "2. 验证代码",
          "infoKey": "设置密钥",
          "infoKeyTitle": "您的双重验证密钥",
          "infoScanBottom": "无法扫描？您可以使用 {0} 手动配置 Authenticator 应用。",
          "infoVerify": "输入由您的 Authenticator 应用生成的代码。",
          "success": "您的身份验证设备已注册。现在您可以用它来登录。",
          "title": "注册您的双重身份验证设备"
        },
        "oathDelete": {
          "error": "删除身份验证设备时发生错误。",
          "success": "身份验证设备已删除。"
        },
        "passkeys": {
          "about": {
            "info1": "Passkey 是一对由您控制的验证器存储的加密密钥（公钥和私钥）。验证器可以证明用户在场并被授权使用 passkey。验证器根据能力和配置，通过 PIN、代码、生物识别或设备密码来证明授权。验证器形式多样，例如 iPhone 或 Android 设备、Windows Hello、FIDO2 硬件安全密钥或密码管理器。",
            "info2": "当您使用 passkey 登录 STIHL 时，您的验证器使用公钥密码学向 STIHL 证明您的身份，而无需发送 passkey 本身。Passkey 绑定到网站域（如 stihl-sso.com）并要求安全连接，这意味着浏览器将拒绝在仿冒的钓鱼网站上进行身份验证。这些特性使 passkey 具有很高的防钓鱼能力，也比 SMS 或 TOTP 2FA 更难被攻击。",
            "info3": "支持云的 passkey 服务允许在设备之间同步 passkey（例如 Apple 设备、Android 设备或密码管理器），从而可以在更多地方使用并且更不容易丢失。当您在一台设备上设置了同步的 passkey 后，它可在使用同一服务的多台设备上使用。例如，如果您使用 MacBook 的 Touch ID 在 iCloud 账户中注册了 passkey，则之后可以在与该 iCloud 账户关联的多台设备上，使用人脸、指纹、PIN 或设备密码来互换使用该 passkey。",
            "title": "关于 Passkeys"
          },
          "add": {
            "button": "添加新的 Passkey",
            "error": "添加新 passkey 时发生错误。",
            "success": "已添加新的 passkey。"
          },
          "delete": {
            "button": "删除 Passkey",
            "error": "删除此 passkey 时发生错误。",
            "success": "已删除 Passkey。"
          },
          "edit": {
            "error": "保存 passkey 名称时发生错误。",
            "name": "Passkey 名称",
            "success": "Passkey 名称已更新。",
            "title": "为您的 Passkey 取一个名称以便与其他 passkey 区分"
          },
          "info": "Passkey 是密码的简单且安全的替代方案，可通过触控、面部识别、设备密码或 PIN 验证您的身份。",
          "none": "尚未配置任何 Passkey。",
          "reallyDelete": "确定要删除 Passkey 吗？",
          "registeredPasskeys": "您已注册的 Passkey：",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "确定要删除身份验证设备吗？",
        "secMFA": "双重身份验证",
        "secPwdChange": "更改密码",
        "title": "安全"
      },
      "setPW": {
        "acceptTC": "请确认我们的 {terms} 并阅读我们的 {privacy}。",
        "killSSO": "使所有活动会话失效",
        "msg": {
          "tokenExpired": "密码链接或代码已过期。请按照链接重置您的密码：{link}."
        },
        "privacy": "数据隐私政策",
        "terms": "条款与条件",
        "title": "输入新密码"
      }
    },
    "validations": {
      "hasDigit": "必须包含数字",
      "hasLowercase": "必须包含小写字母",
      "hasSpecial": "必须包含特殊字符：{chars}",
      "hasUppercase": "必须包含大写字母",
      "invalidCharacters": "包含无效字符",
      "maxLength": "最多允许 {max} 个字符",
      "minLength": "至少需要 {min} 个字符",
      "notSameAsEmail": "与电子邮箱地址过于相似",
      "onlyValidCharactersAllowed": "仅允许字母、数字和空格。",
      "required": "必填项",
      "sameAsPassword": "两次输入的密码不一致",
      "tcAccepted": "请确认我们的条款与条件。",
      "validEmail": "无效的电子邮箱地址。",
      "validOTP": "请输入验证码。"
    }
  }
}
